// extracted by mini-css-extract-plugin
module.exports = {"root":"TableRow-root-3WAuA","body":"TableRow-body-2PEv5"};